export const FETCH_FOOTER_LINKS = 'FETCH_FOOTER_LINKS';
export const SET_FOOTER_LINKS = 'SET_FOOTER_LINKS';